"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _SocketEvents = require("../../constants/SocketEvents");
var _toggleNotificationList = _interopRequireDefault(require("./toggleNotificationList"));
var _Sources = require("@studio/constants/Sources");
var _excluded = ["attendeeId", "name", "presenterPhoto"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function knockReceived(knockPayload) {
  return function (dispatch, getState, socket) {
    var _knockPayload;
    var _getState = getState(),
      attendeeRoster = _getState.attendeeRoster,
      broadcast = _getState.broadcast,
      attendeeResponse = _getState.meeting.attendeeResponse;

    // If attendeeId already exists in attendeeRoster update it to the new name
    if ((_knockPayload = knockPayload) !== null && _knockPayload !== void 0 && _knockPayload.attendeeId) {
      var _knockPayload2 = knockPayload,
        attendeeId = _knockPayload2.attendeeId,
        name = _knockPayload2.name,
        presenterPhoto = _knockPayload2.presenterPhoto,
        rest = _objectWithoutProperties(_knockPayload2, _excluded);
      attendeeRoster[attendeeId] = {
        name: name,
        role: _Sources.SOURCE_ROLE_SPEAKER,
        presenterPhoto: presenterPhoto
      };
      knockPayload = rest;
      socket.emit(_SocketEvents.ATTENDEE_ROSTER_CHANGE, {
        attendeeRoster: attendeeRoster,
        broadcastId: broadcast === null || broadcast === void 0 ? void 0 : broadcast._id,
        notifyingDirector: attendeeResponse && attendeeResponse.Attendee.AttendeeId
      });
    }
    var action = {
      type: _types.BROADCAST_RECEIVE_KNOCK,
      payload: _objectSpread({}, knockPayload)
    };
    dispatch(action);

    // Toggle notification list
    dispatch((0, _toggleNotificationList["default"])(true));
  };
}
var _default = exports["default"] = knockReceived;